<template>
	<v-snackbar
		v-model="showNotification"
		:multi-line="true"
		:vertical="false"
		dark
		color="white"
		:class="`primary--text ${notification.type}`"
		:timeout="notificationTimeout"
		@mouseleave="resetTimeout"
		@mouseenter="stopTimeout"
	>
		{{ notification.text }}
		<div class="v-snack__actions">
			<v-btn
				v-if="notification.direction === 'received'"
				color="primary"
				flat
				to="/messages/"
				@click="reply"
			>Reply</v-btn>
			<v-btn color="primary" flat @click="removeNotification">Close</v-btn>
		</div>
	</v-snackbar>
</template>

<script>
import { mapMutations } from "vuex";

export default {
	data() {
		return {
			isHovered: false
		};
	},

	props: {
		notification: {
			default() {
				return {};
			}
		},

		index: {
			default: 0
		}
	},

	computed: {
		showNotification: {
			get() {
				return this.notification.show;
			},
			set(value) {
				this.REMOVE_NOTIFICATION(this.index);
			}
		},

		notificationTimeout() {
			if (this.isHover) {
				return 0;
			}

			return this.notification.timeout ? this.notification.timeout : 7000;
		}
	},

	methods: {
		...mapMutations(["REMOVE_NOTIFICATION"]),

		removeNotification() {
			this.REMOVE_NOTIFICATION(this.index);
		},

		reply() {
			this.removeNotification();
		},

		resetTimeout() {
			this.isHovered = false;
			// console.log(this.isHovered);

			// this.notificationTimeout = this.notification.timeout
			// 	? this.notification.timeout
			// 	: 7000;
		},

		stopTimeout() {
			this.isHovered = true;
			// console.log(this.isHovered);
			// this.notificationTimeout = 0;
		}
	}
};
</script>
